<template>
  <v-row class="d-flex justify-center ma-0 pa-0 fill-height">
    <v-col cols="12" lg="10" md="7">
      <v-card class="card-shadow bg-secondary">
        <ExibicaoPromocao />
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import ExibicaoPromocao from "../Components/Exibicoes/ExibicaoPromocao.vue";
export default {
  name: "ShowPromo",
  components: {
    ExibicaoPromocao,
  },
  data() {
    return {};
  },
};
</script>
